import React from 'react'
import { FormattedMessage as Lang } from 'react-intl'
import WidgetsDashboardIcon from '@/components/icons/widgetsDashboard'

export default {
  main: [
    {
      name: <Lang id="widgets.light" />,
      selector: 'outdoorLightningCount',
    },
    {
      name: <Lang id="widgets.roadRepairingCount" />,
      selector: 'roadRepairingCount',
    },
    {
      name: <Lang id="widgets.transportStationCount" />,
      selector: 'transportStationCount',
    },
    {
      name: <Lang id="widgets.notAvailable1" />,
      selector: 'notAvailable1',
      disabled: true,
    },
    {
      name: <Lang id="widgets.notAvailable2" />,
      selector: 'notAvailable2',
      disabled: true,
    },
  ],
  view: {
    title: <Lang id="widgetsDashboard.tyumenOurHomeBigWidget" />,
    icon: WidgetsDashboardIcon.TyumenOurHomeBigWidgetIcon,
  },
  total: {
    name: <Lang id="widgetsDashboard.totalCalls" />,
    selector: 'totalAppealsAmount',
  },
  solved: {
    name: <Lang id="widgetsDashboard.decisionWasMadeMany" />,
    selector: 'numberProblemSolved',
  },
  graph: {
    totalSelector: 'totalAppealsAmount',
    solvedSelector: 'numberProblemSolved',
  },
}
